import { CertificateObj, Certificates } from './certificates'
import { Signer } from './signer'
import { certificatesIterator } from './certificatesIterator'

export class ClosedCertificates extends Certificates {
  async init () {
    let lst = document.getElementById(this.certListBoxId)
    lst.innerHTML = ''
    for await (const certificate of certificatesIterator()) {
      this.certificates.push(certificate)
    }

    for (const certificate of this.certificates) {
      let validFrom = await certificate.ValidFromDate
      let validTo = await certificate.ValidToDate
      let certObj = new CertificateObj(certificate, validFrom, validTo)

      let oOpt = document.createElement('option')
      let subjectName = await certObj.cert.SubjectName
      let algorithmName = await certObj.GetFriendlyName()
      oOpt.text = await certObj.GetCertString(subjectName, algorithmName)

      oOpt.value = this.counter
      this.counter++

      lst.options.add(oOpt)
    }
    this.Signer.certificates = this.certificates

    if (lst[0]) {
      lst.value = 0
      lst.dispatchEvent(new Event('change'))
      lst.focus()
    }
  }
}

export class ClosedSigner extends Signer {
  async requestCertificates () {
    if (!this.Certificates) {
      this.Certificates = new ClosedCertificates({
        certListBoxId: this.certListBoxId,
        Signer: this
      })
    }
  }
}
